import { render, staticRenderFns } from "./KeywordTransfer.vue?vue&type=template&id=94941e18&"
import script from "./KeywordTransfer.vue?vue&type=script&lang=ts&"
export * from "./KeywordTransfer.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./KeywordTransfer.vue?vue&type=style&index=0&id=94941e18&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-wizard/mfe-ca-wizard/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94941e18')) {
      api.createRecord('94941e18', component.options)
    } else {
      api.reload('94941e18', component.options)
    }
    module.hot.accept("./KeywordTransfer.vue?vue&type=template&id=94941e18&", function () {
      api.rerender('94941e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KeywordTransfer.vue"
export default component.exports